import { useCallback, useState } from 'react';

interface PaginateData {
    total_items: number;
}
export interface CoinData {
    price: {
        buyAmount: string;
        buyAmountToman: string;
        buyPrice: string;
        buyPriceToman: string;
        sellAmount: string;
        sellAmountToman: string;
        sellPrice: string;
        sellPriceToman: string;
    };
    symbol: string;
    iconUrl: string;
}
interface ApiResponse {
    data: {
        exchange: {
            coinData: CoinData[];
            registerLink: string;
        };
        paginate_data: PaginateData;
    };
}

const useExchangeList = (slug: string) => {
    const [exchangeList, setExchangeList] = useState<CoinData[]>([]);
    const [registerLink, setRegisterLink] = useState<string>();
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(10);
    const [totalPages, setTotalPages] = useState<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const fetchExchanges = useCallback(
        async (currentPage: any) => {
            setIsLoading(true);
            setError(null);
            try {
                const url = `/api/coin/exchangesList/?slug=${slug}&page=${currentPage}&limit=${pageSize}`;

                const res = await fetch(url);
                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }
                const json: ApiResponse = await res.json();
                setExchangeList(json.data.exchange.coinData);
                setRegisterLink(json.data.exchange.registerLink);
                setTotalPages(json.data.paginate_data.total_items);
            } catch (err) {
                setError('Error fetching coins');
                console.error('Error fetching coins:', err);
            } finally {
                setIsLoading(false);
            }
        },
        [pageSize, slug],
    );

    return {
        exchangeList,
        currentPage,
        pageSize,
        totalPages,
        isLoading,
        error,
        registerLink,
        setCurrentPage,
        setPageSize,
        fetchExchanges,
    };
};

export default useExchangeList;
